
export default {
  props: {
    label: String,
    content: String,
  },

  data () {
    return {
      attributes: []
    }
  },

  computed: {
    _content: {
      set (value) {
        this.$emit('update:content', value)
      },

      get () {
        return this.content
      }
    }
  },

  methods: {
    onDayClick (val) {
      this.attributes = []
      this.attributes.push({
        dates: val.date,
        highlight: {
          contentClass: '--highlight'
        }
      })
      this._content = val.id
    }
  },

  mounted () {
    if (this.content === undefined) this._content = null
  }
}
